import React, { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import AuthShell from "./AuthShell";
import { Mail, CheckCircle, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const redirectUrl = window.location.origin + "/reset-password";
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: redirectUrl,
      });
      if (error) throw error;
      setSuccess(true);
    } catch (e2) {
      setErr(e2.message || "Erro ao tentar enviar o e-mail de recuperação.");
    } finally {
      setBusy(false);
    }
  };

  if (success) {
    return (
      <AuthShell
        title="E-mail enviado!"
        subtitle="Verifique sua caixa de entrada para continuar."
        footer={
          <Link to="/login" className="ds-btn-ghost w-full flex items-center justify-center gap-2 text-sm text-[hsl(var(--text-secondary))]">
            <ArrowLeft className="w-4 h-4" /> Voltar para o Login
          </Link>
        }
      >
        <div className="ds-card p-6 flex flex-col items-center text-center bg-emerald-500/10 border-emerald-500/20">
          <div className="w-16 h-16 rounded-full bg-white/50 flex items-center justify-center mb-4 shadow-sm">
            <CheckCircle className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="text-lg font-bold tracking-tight mb-2" style={{ fontFamily: "'Outfit',sans-serif" }}>
            Link enviado com sucesso
          </h3>
          <p className="text-sm text-[hsl(var(--text-secondary))]">
            Enviamos um link seguro de recuperação para <strong>{email}</strong>. Clique no link para definir sua nova senha.
          </p>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Recuperar senha"
      subtitle="Digite seu e-mail e enviaremos um link para redefinir sua senha."
      footer={
        <div className="text-sm text-[hsl(var(--text-secondary))] text-center">
          Lembrou sua senha?{" "}
          <Link to="/login" className="ds-link font-bold text-[hsl(var(--brand))]">Entrar</Link>
        </div>
      }
    >
      <form onSubmit={submit} className="space-y-4">
        <label className="block">
          <span className="text-xs font-medium text-[hsl(var(--text-secondary))] mb-1.5 block">E-mail</span>
          <div className="relative">
            <input
              type="email"
              required
              className="ds-input pl-11 h-11"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
            />
            <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[hsl(var(--text-tertiary))]">
              <Mail className="w-4 h-4" />
            </div>
          </div>
        </label>

        {err && (
          <div className="text-sm text-[hsl(var(--danger-text))] bg-[hsl(var(--danger-bg))] rounded-md px-3 py-2">
            {err}
          </div>
        )}

        <button disabled={busy} className="ds-btn-primary w-full h-11 font-bold">
          {busy ? "Enviando..." : "Enviar link de recuperação"}
        </button>
      </form>
    </AuthShell>
  );
}
